import WebpackBackend from '../WebpackBackend';
import { bundleNotFoundMessage, novaLocaleToFileExtension, unsupportedBundleMessage } from './util';

/**
 * Important: This class should ONLY be used when there are NO Viya services in your environment.
 *
 * Provides translations for SASDesign-Icon-gui-icu bundle from npm package.
 * To use also install '@sas/github-localization-repository'.
 */
export class SASDesignNpmWebpackBackend extends WebpackBackend {
  async import(locale, bundleName) {
    // Prefer to get en bundles from NovaWebpackBackend. Those will always be in sync with whatever the
    // components need. Getting en from @sas/github-localization-repository could result in out of date en
    // bundles if the consumer is not diligent about updating @sas/github-localization-repository.
    if (locale === 'en' || bundleName !== 'SASDesign-Icon-gui-icu') throw unsupportedBundleMessage(locale, bundleName);
    try {
      return (await import(`@sas/github-localization-repository/bundles/sas-institute-rnd-product/design-system-site/SASDesign-Icon-gui-icu${novaLocaleToFileExtension(locale)}.properties`)).default;
    } catch (e) {
      throw bundleNotFoundMessage(locale, bundleName);
    }
  }
}
//# sourceMappingURL=SASDesignNpmWebpackBackend.js.map